
const { TableClient, AzureSASCredential, TableTransaction } = require("@azure/data-tables");

const configurationManager = require('../config/configurationManager.js');
const logger = require('../logger/logger.js');
const stringUtil = require('../string/stringUtil');

export async function upsertEntity(tableName, entity)
{
    try
    {
        logger.info(`Executing the upsert entity for table ${tableName}`);

        if (stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountName) ||
            stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken))
            throw "No configuration found for azure table connection string";

        const clientWithSAS = new TableClient(`https://${configurationManager.getConfig().azureReferenceDataStorageAccountName}.table.core.windows.net`,
                                            tableName,
                                            new AzureSASCredential(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken));

        const metricStartTime = Date.now();
        await clientWithSAS.upsertEntity(entity, "Replace");

        const metricValueInMS = Date.now() - metricStartTime;
        logger.metrics(`AZURE.TABLE.UPSERT.${tableName}`, metricValueInMS, `Total time required to upsert an entity in table ${tableName}`);
        return Promise.resolve(true);
    }
    catch(error)
    {
        let errorMessage = `Following error reported while upserting entity: ${tableName}. ${error}`;
        logger.error(errorMessage, {}, error);
        return Promise.reject(errorMessage);
    }
}

export async function upsertEntities(tableName, entities)
{
    try
    {
        if (stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountName) ||
            stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken))
            throw "No configuration found for azure table connection string";

        const clientWithSAS = new TableClient(`https://${configurationManager.getConfig().azureReferenceDataStorageAccountName}.table.core.windows.net`,
                                            tableName,
                                            new AzureSASCredential(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken));


        let transaction = new TableTransaction();
        entities.forEach (entity =>
            {
                transaction.upsertEntity(entity, "Replace");
            })

        await clientWithSAS.submitTransaction(transaction.actions);
        return Promise.resolve(true);
    }
    catch(error)
    {
        let errorMessage = `Following error reported while upserting entities: ${tableName}. ${error}`;
        logger.error(errorMessage, {}, error);
        return Promise.reject(errorMessage);
    }
    
}


export async function loadEntities(tableName, query)
{
    try
    {
        if (stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountName) ||
            stringUtil.isStringNullOrEmpty(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken))
            throw "No configuration found for azure table connection string";

        const clientWithSAS = new TableClient(`https://${configurationManager.getConfig().azureReferenceDataStorageAccountName}.table.core.windows.net`,
                                            tableName,
                                            new AzureSASCredential(configurationManager.getConfig().azureReferenceDataStorageAccountNameSaSToken));

        let pageIterator = clientWithSAS.listEntities({ queryOptions: query });
        const pageEntities = [];
        for await (const page of pageIterator)
        {
            pageEntities.push(page);
        }

        return pageEntities;
    }
    catch(error)
    {
        logger.error(`Following error reported while loading entities: ${tableName}. ${error}`, {}, error);
        Promise.reject(error);
    }
}

export function removeInvalidCharacters(value)
{
    value = stringUtil.replaceAll(value, "/", "");
    value = stringUtil.replaceAll(value, "\\", "");
    value = stringUtil.replaceAll(value, "#", "");
    value = stringUtil.replaceAll(value, "?", "");
    value = stringUtil.replaceAll(value, " ", "");
    value = stringUtil.replaceAll(value, "\t", "");
    value = stringUtil.replaceAll(value, "\n", "");
    value = stringUtil.replaceAll(value, "\r", "");
    return value;
}